import { FormItem } from "../../../../base-data/area-building/model/form-item-interface";

export const BID_TABLE_CONTENT_TABLE1: FormItem[] = [
  { text: 'BidCreat.Item', value: "id"},
  { text: 'BidCreat.ProjectName', value: "projectName"},
  { text: 'BidCreat.Proportion', value: "ratio"},
  { text: 'BidCreat.Unit', value: "unit"},
  { text: 'BidCreat.Quantity', value: "count"},
  { text: 'BidCreat.TotalPriceWithTax', value: "tatalPriceWithVat"},
  { text: 'BidCreat.Remark', value: "remark"},
];


// export const BID_TABLE_CONTENT_TABLE2: FormItem[] = [
//   { text: 'BidCreat.Item', value: "Item"},
//   { text: 'BidCreat.PN', value: "pn"},
//   { text: 'BidCreat.PrimaryCategory', value: "bigType"},
//   { text: 'BidCreat.SecondaryCategory', value: "middleType"},
//   { text: 'BidCreat.MinorCategory', value: "smallType"},
//   { text: 'BidCreat.ProjectName', value: "projectName"},
//   { text: 'BidCreat.BrandOrigin', value: "specType"},
//   { text: 'BidCreat.SpecModel', value: "specType"},
//   { text: 'BidCreat.Unit', value: "unit"},
//   { text: 'BidCreat.Quantity', value: "quantity"},
//   { text: 'BidCreat.UntaxedUnitPrice', value: "notInUnitPrice"},
//   { text: 'BidCreat.UntaxedTotalPrice', value: "notInTotalPrice" },
//   { text: 'BidCreat.Remark', value: "remark"},
// ];
